import type { FC } from "react";
import type React from "react";
import {
  FormControl,
  InputAdornment,
  Input,
  InputLabel,
  FormHelperText,
  Typography,
  Tooltip,
} from "@mui/material";
import { withStyles } from "@mui/styles";
import { withFormField } from "@fas/ui-core";
import { useAuth } from "@fas/cpa-state-manager/hooks";
import { withState } from "@fas/cpa-cabinet-ui";
import {
  formFieldLabelStyles,
  formFieldInputStyles,
  formFieldGradientIconStyles,
} from "../../styles";

const StyledInputLabel = withStyles(formFieldLabelStyles)(InputLabel);
const StyledInput = withStyles(formFieldInputStyles)(Input);
const SpacedStyledInput = StyledInput;
const StyledInputAdornment = withStyles(formFieldGradientIconStyles)(
  InputAdornment
);

export type Props = {
  name: string;
  label: string;
  disabled?: boolean;
  type?: string;
  "data-testid"?: string;
  placeholder?: string;
  StartIcon?: React.JSX.Element;
  EndIcon?: React.JSX.Element;
  error?: string;
  value?: any;
  onChange?: (arg0: any) => any;
  onClick?: (arg0: any) => any;
  onKeyPress?: (arg0: React.KeyboardEvent<any>) => any;
  autoFocus?: boolean;
  sx?: any;
  slotProps?: any;
  formControlSx?: any;
  inputProps?: any;
  className?: any;
  isAuthenticated?: boolean;
};

const defaultChange: (arg0: any) => any = (e) => e;

const defaultType = "text";
export const TextFieldForm: FC<Props> = ({
  name,
  label,
  error,
  value,
  StartIcon,
  EndIcon,
  sx,
  onKeyPress,
  autoFocus,
  placeholder,
  disabled = false,
  type = defaultType,
  onChange = defaultChange,
  onClick,
  "data-testid": dataTestId,
  isAuthenticated = false,
  inputProps,
  className,
  formControlSx = {
    mb: 2,
  },
  slotProps,
}: Props) => (
  <Tooltip title="" {...slotProps?.tooltip}>
    <FormControl sx={formControlSx} variant="standard" fullWidth>
      <StyledInputLabel htmlFor={name} authenticated={String(isAuthenticated)}>
        <Typography component="p">
          {label}
        </Typography>
      </StyledInputLabel>
      <SpacedStyledInput
        authenticated={String(isAuthenticated)}
        data-testid={dataTestId || name}
        id={name}
        sx={sx}
        fullWidth
        disableUnderline
        variant="filled"
        type={type}
        margin="dense"
        placeholder={placeholder || label}
        value={value}
        disabled={disabled}
        autoFocus={Boolean(autoFocus)}
        onChange={(e) => onChange(e.target.value)}
        onClick={onClick}
        onKeyPress={onKeyPress}
        error={Boolean(error)}
        startAdornment={
          StartIcon && (
            <StyledInputAdornment position="end">
              {StartIcon}
            </StyledInputAdornment>
          )
        }
        endAdornment={
          EndIcon && <InputAdornment position="start">
            {EndIcon}
          </InputAdornment>
        }
        inputProps={inputProps}
        className={className}
      />
      <FormHelperText
        sx={{
          whiteSpace: "pre-wrap",
        }}
        data-testid={`${name}-error`}
        error={Boolean(error)}
      >
        {error}
      </FormHelperText>
    </FormControl>
  </Tooltip>
);

export default withState(withFormField(TextFieldForm), useAuth);
